// extracted by mini-css-extract-plugin
export var BlogPosts = "BlogPosts-module--BlogPosts--AkQiS";
export var aniSpin = "BlogPosts-module--ani-spin--z6faz";
export var container = "BlogPosts-module--container--gbLZH";